import { UseGetStoreData } from "../getStoreData/UseGetStoreData"
const useTrackAgentNotes = () => {
    const {getTicketData}=UseGetStoreData();   
    const getTrackStatus=()=>{
        const status=getTicketData&&getTicketData?.notes?.map((note)=>
            note.message
        );
        
        let newStep = [0, 0, 0, 0];
        if(status.includes("ambulanceDispatched")){
            newStep[0] = 1; 
        }
        if(status.includes("ambulanceArrivedPickupLocation")){
            newStep[1] = 1; 
        }
        if(status.includes("patientPicked")){
            newStep[2] = 1; 
        }
        if(status.includes("patientDropped")){
            newStep[3] = 1; 
        }
        return newStep;

    };    
 return {getTrackStatus}
}

export default useTrackAgentNotes